// Shared admin login check for the bootcamp and masterclass admin pages.
// Note: this runs in the browser, so it only hides the page; it does not secure the API.
export const checkAdminCredentials = (username, password) =>
  username === "admin" && password === "0nly4i2i$TopSecret!";
